export const getColor = ({ color, disabled, alt, theme }) => {
    if (disabled) {
        return theme.colors.grey70_1;
    }
    if (color) {
        return color;
    }
    if (alt) {
        return theme.colors.grey00_2;
    }
    return theme.colors.black_1;
};
